import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import PageListHeader from 'modules/_shared/components/Headers/PageListHeader';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import Button from 'modules/_shared/components/Buttons';
import HoldingClassListPageBody from './components/HoldingClassListPageBody';
import { useHoldingClassListPage } from './context/HoldingClassListPageContext';

const HoldingClassList: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useHoldingClassListPage();

  const pageActions = [
    <Button onClick={actions.handleAddClass} disabled={data.isReadOnly}>
      <em className="icon ni ni-plus" />
      <span>{t('AddClass')}</span>
    </Button>,
  ];

  return (
    <Page>
      <PageListHeader
        subTitle={t('ParticipationClasses')}
        description={`${data.societyName} ${t('HaveHoldingClasses', {
          count: data.holdingClassesTotal,
        })}`}
        actions={data.isAdmin && !data.isReadOnly ? pageActions : []}
      />

      <HoldingClassListPageBody />

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default HoldingClassList;
